import { AxiosError } from 'axios'

import { useMutation, UseMutationOptions } from '@tanstack/react-query'

import { IErrorDTO } from '@/DTOs/errorDTO'

import { updateMyAccount } from './services'
import { TGetMyAccountResponse, TUpdateMyAccountParams } from './types'

export const useMutationUpdateMyAccount = (
  options?: UseMutationOptions<
    TGetMyAccountResponse,
    AxiosError<IErrorDTO>,
    TUpdateMyAccountParams
  >
) => {
  return useMutation<
    TGetMyAccountResponse,
    AxiosError<IErrorDTO>,
    TUpdateMyAccountParams
  >(data => updateMyAccount(data), options)
}
